import { CTRL_NAME_EXTRACTOR } from "../../formulaires/validators/ctrl.name.extractor";

export class ArrayPopTools {

    public static pop<T>(array : T[], i, form, Uid): T[] {
		var controls = CTRL_NAME_EXTRACTOR.getCtrlNames(form, Uid + '_index_');
		for(let j = i + 1; j < array.length; j++) {
			 controls.forEach(control => {
				if(control.includes(Uid + '_index_' + j)) {
					if(form.controls[control.replace(Uid + '_index_' + j, Uid + '_index_' + (j + 1))] != undefined)
					form.controls[control].setValue(form.controls[control.replace(Uid + '_index_' + j, Uid + '_index_' + (j + 1))].value)
				}
			})
		}array.pop();
        return array;
    }
}